import * as i0 from '@angular/core';
import { NgModule, inject, isDevMode, Injectable } from '@angular/core';
import * as i2 from '@spartacus/core';
import { LoggerService } from '@spartacus/core';
import { EMPTY } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as i1 from '@spartacus/tracking/personalization/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let PersonalizationCoreModule = /*#__PURE__*/(() => {
  class PersonalizationCoreModule {
    static {
      this.ɵfac = function PersonalizationCoreModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PersonalizationCoreModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PersonalizationCoreModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return PersonalizationCoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let PersonalizationContextService = /*#__PURE__*/(() => {
  class PersonalizationContextService {
    constructor(config, cmsService) {
      this.config = config;
      this.cmsService = cmsService;
      this.logger = inject(LoggerService);
    }
    getPersonalizationContext() {
      if (!this.config.personalization?.context) {
        if (isDevMode()) {
          this.logger.warn(`There is no context configured in Personalization.`);
        }
        return EMPTY;
      } else {
        const context = this.config.personalization.context;
        return this.cmsService.getCurrentPage().pipe(filter(Boolean), map(page => page.slots?.[context.slotPosition]), filter(Boolean), map(slot => {
          const scriptComponent = slot.components?.find(i => i.uid === context.componentId);
          return this.buildPersonalizationContext(scriptComponent?.properties?.script?.data);
        }));
      }
    }
    buildPersonalizationContext(data) {
      if (data) {
        const context = JSON.parse(atob(data));
        context.actions.forEach(action => {
          Object.keys(action).forEach(key => {
            action[key] = atob(action[key]);
          });
        });
        for (let i = 0; i < context.segments.length; i++) {
          context.segments[i] = atob(context.segments[i]);
        }
        return context;
      }
    }
    static {
      this.ɵfac = function PersonalizationContextService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PersonalizationContextService)(i0.ɵɵinject(i1.PersonalizationConfig), i0.ɵɵinject(i2.CmsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PersonalizationContextService,
        factory: PersonalizationContextService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PersonalizationContextService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PersonalizationContextService, PersonalizationCoreModule };
